import { injectable } from 'inversify';

import { OperationResult } from '@vp/common/core/OperationResult';
import { AvatarManagerPort } from '@vp/manager/avatar/core/interfaces/AvatarManagerPort';
import { RemoveAvatarUsecase } from '@vp/manager/avatar/core/usecase/RemoveAvatarUsecase';
import { UploadAvatarUsecase } from '@vp/manager/avatar/core/usecase/UploadAvatarUsecase';
import { MakeLiveUsecase } from '@vp/manager/gallery/core/usecase/MakeLiveUsecase';
import { MakeStaticUsecase } from '@vp/manager/gallery/core/usecase/MakeStaticUsecase';
import { ProfileManagerState } from '@vp/manager/profile/core/interface/ProfileManagerState';

@injectable()
export class AvatarManagerFacade implements AvatarManagerPort {
  constructor(
    private readonly removeAvatarUsecase: RemoveAvatarUsecase,
    private readonly uploadAvatarUsecase: UploadAvatarUsecase,
    private readonly profileManagerState: ProfileManagerState,
    private readonly makeLiveUsecase: MakeLiveUsecase,
    private readonly makeStaticUsecase: MakeStaticUsecase,
  ) {}

  async makeLive(controller?: AbortController): Promise<OperationResult> {
    const imageId = this.profileManagerState.active.value!.image.id;
    return this.makeLiveUsecase.execute(imageId, controller);
  }

  async makeStatic(controller?: AbortController): Promise<OperationResult> {
    const imageId = this.profileManagerState.active.value!.image.id;
    return this.makeStaticUsecase.execute(imageId, controller);
  }

  hasProfileImageAnimationAttempts(): boolean {
    return this.profileManagerState.hasProfileImageAnimationAttempts();
  }

  async remove(profileId: string, avatarId: string, controller?: AbortController): Promise<boolean> {
    return await this.removeAvatarUsecase.execute(profileId, avatarId, controller);
  }

  async upload(profileId: string, avatarFile: File, controller?: AbortController): Promise<boolean> {
    return await this.uploadAvatarUsecase.execute(profileId, avatarFile, controller);
  }
}
